import { Component, OnInit, SecurityContext } from '@angular/core';
import { CONFIG } from '../config';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonService } from '../common.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {

  constructor(private sanitizer: DomSanitizer, private commonService:CommonService) { }
  safeNavigate(url: string) {
    const sanitizedUrl = this.sanitizer.sanitize(SecurityContext.URL, url);
    if (sanitizedUrl) {
      window.location.href = sanitizedUrl;
    }
  }
  ngOnInit(): void {
    if (localStorage.getItem('currentUser')) {
      const ssoConfig = CONFIG.getSSOConfig();
      // logged in so end FR session first
      const user = JSON.parse(localStorage.getItem('currentUser'));
      const endSessionUrl = `${ssoConfig.end_session_endpoint}?id_token_hint=${user.idToken}&post_logout_redirect_uri=${ssoConfig.post_logout_redirect_uri}`;
      
      this.commonService.logout().subscribe(data => {
        if(data.body.message=='Success')
        {
          sessionStorage.clear();
          localStorage.clear(); //
          this.clearSession();
          this.safeNavigate(endSessionUrl);
        }
       

      });

      // window.location.href = endSessionUrl;
    }
  }
  private clearSession() {
    // Clear session cookies
    document.cookie.split(";").forEach((c) => {
      document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });

}

}
